export const getConsumptionObject = (premiumFlagArray, ownerId) => {
  try {
    const premiumFlag = premiumFlagArray.filter(obj => obj.user_id === ownerId);
    if (premiumFlag.length > 0) {
      return premiumFlag[0];
    }
    return {};
  } catch (e) {
    console.log(e);
  }
};

export const updateConsumptionArray = (
  premiumFlagArray=[],
  newPremiumFlagObject
) => {
  try {
    const matchedPremiumFlagIndex = premiumFlagArray.findIndex(
      obj => obj.user_id === newPremiumFlagObject.user_id
    );
    if (matchedPremiumFlagIndex !== -1) {
      return [
        ...premiumFlagArray.slice(0, matchedPremiumFlagIndex),
        { ...newPremiumFlagObject },
        ...premiumFlagArray.slice(matchedPremiumFlagIndex + 1)
      ];
    }
    return [...premiumFlagArray, newPremiumFlagObject];
  } catch (e) {
    console.log(e);
  }
};
